import React, { useState } from 'react';
import { Search, Check, Loader2, X, ArrowRight, ChevronRight } from 'lucide-react';
import { Widget } from './Widget';
type Status = 'Consegnata' | 'In transito' | 'Da firmare' | 'Fallita' | 'In ritardo';
type Signed = 'ok' | 'pending' | 'failed' | 'none';
const SHIPMENTS: {
  id: string;
  store: string;
  city: string;
  carrier: string;
  colli: number;
  status: Status;
  signed: Signed;
  cost: string;
  updated: string;
}[] = [{
  id: 'SH-7H2K9P',
  store: 'Store Milano Duomo',
  city: 'Milano',
  carrier: 'FedEx',
  colli: 6,
  status: 'Consegnata',
  signed: 'ok',
  cost: '€ 48,20',
  updated: '12 min fa'
}, {
  id: 'SH-3M8N1Q',
  store: 'Store Roma Termini',
  city: 'Roma',
  carrier: 'FedEx',
  colli: 4,
  status: 'In transito',
  signed: 'pending',
  cost: '€ 62,10',
  updated: '24 min fa'
}, {
  id: 'SH-9F4D2R',
  store: 'Store Firenze Centro',
  city: 'Firenze',
  carrier: 'GLS',
  colli: 5,
  status: 'Da firmare',
  signed: 'pending',
  cost: '€ 41,65',
  updated: '38 min fa'
}, {
  id: 'SH-5J7L8X',
  store: 'Store Bari Mungivacca',
  city: 'Bari',
  carrier: 'UPS',
  colli: 8,
  status: 'In ritardo',
  signed: 'ok',
  cost: '€ 78,40',
  updated: '1 h fa'
}, {
  id: 'SH-2K6V4T',
  store: 'Store Palermo La Torre',
  city: 'Palermo',
  carrier: 'FedEx',
  colli: 7,
  status: 'Consegnata',
  signed: 'ok',
  cost: '€ 64,95',
  updated: '2 h fa'
}, {
  id: 'SH-8P1S3W',
  store: 'Store Catania Etnapolis',
  city: 'Catania',
  carrier: 'SDA',
  colli: 3,
  status: 'Fallita',
  signed: 'failed',
  cost: '€ 32,80',
  updated: '3 h fa'
}, {
  id: 'SH-6B9C5Y',
  store: 'Store Torino Lingotto',
  city: 'Torino',
  carrier: 'FedEx',
  colli: 4,
  status: 'In transito',
  signed: 'none',
  cost: '€ 38,40',
  updated: '4 h fa'
}, {
  id: 'SH-4N2Z7H',
  store: 'Store Bologna Centro',
  city: 'Bologna',
  carrier: 'FedEx',
  colli: 6,
  status: 'Consegnata',
  signed: 'ok',
  cost: '€ 54,85',
  updated: '5 h fa'
}];
const FILTERS = ['Tutte', 'In transito', 'Da firmare', 'Consegnate', 'Problemi'];
function StatusBadge({
  status
}: {
  status: Status;
}) {
  const styles: Record<Status, string> = {
    Consegnata: 'bg-[#D4FF3A] text-[#0A0A0A]',
    'In transito': 'bg-[#1F1F1F] text-[#FAFAFA] border border-[#2A2A2A]',
    'Da firmare': 'bg-transparent text-[#D4FF3A] border border-[#D4FF3A]/40',
    Fallita: 'bg-[#EF4444]/10 text-[#EF4444] border border-[#EF4444]/20',
    'In ritardo': 'bg-[#F5A524]/10 text-[#F5A524] border border-[#F5A524]/20'
  };
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-medium ${styles[status]}`} data-id="element-3922">
      {status}
    </span>;
}
function SignedIcon({
  s
}: {
  s: Signed;
}) {
  if (s === 'ok') return <Check className="h-4 w-4 text-[#D4FF3A]" data-id="element-3923" />;
  if (s === 'pending') return <Loader2 className="h-4 w-4 text-[#F5A524] animate-spin" data-id="element-3924" />;
  if (s === 'failed') return <X className="h-4 w-4 text-[#EF4444]" data-id="element-3925" />;
  return <span className="text-[#6B6B6B] text-xs" data-id="element-3926">—</span>;
}
type Props = {
  onShipmentClick?: (id: string) => void;
  onViewAll?: () => void;
};
export function ShipmentsTable({
  onShipmentClick,
  onViewAll
}: Props = {}) {
  const [active, setActive] = useState('Tutte');
  return <Widget title="Spedizioni recenti" bodyPadding="none" headerRight={<div className="flex flex-col sm:flex-row sm:items-center gap-2" data-id="element-3928">
          <div className="-mx-4 sm:mx-0 px-4 sm:px-0 overflow-x-auto" data-id="element-3929">
            <div className="flex items-center gap-1 p-1 rounded-lg bg-[#0A0A0A] border border-[#1F1F1F] w-max sm:w-auto" data-id="element-3930">
              {FILTERS.map(f => <button key={f} onClick={() => setActive(f)} className={`px-2.5 py-1 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${active === f ? 'bg-[#1F1F1F] text-[#FAFAFA]' : 'text-[#9A9A9A] hover:text-[#FAFAFA]'}`} data-id="element-3931">
                  {f}
                </button>)}
            </div>
          </div>

          <div className="relative" data-id="element-3932">
            <Search className="h-4 w-4 text-[#6B6B6B] absolute left-3 top-1/2 -translate-y-1/2" data-id="element-3933" />
            <input type="text" placeholder="Cerca negozio..." className="w-full sm:w-44 pl-9 pr-3 py-1.5 rounded-lg bg-[#0A0A0A] border border-[#1F1F1F] text-xs text-[#FAFAFA] placeholder:text-[#6B6B6B] focus:outline-none focus:ring-2 focus:ring-[#D4FF3A]/30" data-id="element-3934" />
          </div>
        </div>} footerCta={{
    label: 'Vedi tutte le spedizioni',
    onClick: onViewAll
  }} data-id="element-3927">
      {/* Mobile card list */}
      <div className="md:hidden divide-y divide-[#1F1F1F]" data-id="element-3935">
        {SHIPMENTS.map(s => <button key={s.id} onClick={() => onShipmentClick?.(s.id)} className="w-full text-left p-4 active:bg-[#0A0A0A] hover:bg-[#0A0A0A] transition-colors" data-id="element-3936">
            <div className="flex items-start justify-between gap-3 mb-2" data-id="element-3937">
              <div className="min-w-0" data-id="element-3938">
                <div className="font-mono text-xs text-[#FAFAFA]" data-id="element-3939">{s.id}</div>
                <div className="text-sm text-[#FAFAFA] mt-0.5 truncate" data-id="element-3940">
                  {s.store}
                </div>
              </div>
              <StatusBadge status={s.status} data-id="element-3941" />
            </div>
            <div className="flex items-center justify-between gap-3 text-xs text-[#9A9A9A]" data-id="element-3942">
              <div className="flex items-center gap-1.5 min-w-0" data-id="element-3943">
                <span data-id="element-3944">Roma</span>
                <ArrowRight className="h-3 w-3 text-[#6B6B6B] shrink-0" data-id="element-3945" />
                <span className="truncate" data-id="element-3946">{s.city}</span>
                <span className="text-[#6B6B6B] mx-1" data-id="element-3947">•</span>
                <span className="font-mono" data-id="element-3948">{s.colli} colli</span>
              </div>
              <div className="flex items-center gap-2 shrink-0" data-id="element-3949">
                <SignedIcon s={s.signed} data-id="element-3950" />
                <span className="font-mono text-[#FAFAFA]" data-id="element-3951">{s.cost}</span>
              </div>
            </div>
            <div className="mt-1.5 text-[10px] text-[#6B6B6B]" data-id="element-3952">{s.updated}</div>
          </button>)}
      </div>

      {/* Desktop table */}
      <div className="hidden md:block overflow-x-auto" data-id="element-3953">
        <table className="w-full text-sm [&_th]:whitespace-nowrap [&_td]:whitespace-nowrap" data-id="element-3954">
          <thead data-id="element-3955">
            <tr className="text-left text-[10px] uppercase tracking-wider text-[#6B6B6B] border-b border-[#1F1F1F]" data-id="element-3956">
              <th className="px-5 py-3 font-medium" data-id="element-3957">Spedizione</th>
              <th className="px-5 py-3 font-medium" data-id="element-3958">Negozio</th>
              <th className="px-5 py-3 font-medium" data-id="element-3959">Vettore</th>
              <th className="px-5 py-3 font-medium" data-id="element-3960">Destinazione</th>
              <th className="px-5 py-3 font-medium text-center" data-id="element-3961">Colli</th>
              <th className="px-5 py-3 font-medium" data-id="element-3962">Stato</th>
              <th className="px-5 py-3 font-medium text-center" data-id="element-3963">Firma</th>
              <th className="px-5 py-3 font-medium text-right" data-id="element-3964">Costo</th>
              <th className="px-5 py-3 font-medium text-right" data-id="element-3965">Aggiornato</th>
            </tr>
          </thead>
          <tbody data-id="element-3966">
            {SHIPMENTS.map(s => <tr key={s.id} onClick={() => onShipmentClick?.(s.id)} className="border-b border-[#1F1F1F] last:border-0 hover:bg-[#0A0A0A] transition-colors cursor-pointer" data-id="element-3967">
                <td className="px-5 py-3.5 font-mono text-xs text-[#FAFAFA]" data-id="element-3968">
                  {s.id}
                </td>
                <td className="px-5 py-3.5 text-[#FAFAFA]" data-id="element-3969">{s.store}</td>
                <td className="px-5 py-3.5 text-[#9A9A9A]" data-id="element-3970">{s.carrier}</td>
                <td className="px-5 py-3.5 text-[#9A9A9A]" data-id="element-3971">
                  <span className="inline-flex items-center gap-1.5" data-id="element-3972">
                    <span data-id="element-3973">Roma</span>
                    <ArrowRight className="h-3 w-3 text-[#6B6B6B]" data-id="element-3974" />
                    <span data-id="element-3975">{s.city}</span>
                  </span>
                </td>
                <td className="px-5 py-3.5 text-center font-mono text-[#FAFAFA]" data-id="element-3976">
                  {s.colli}
                </td>
                <td className="px-5 py-3.5" data-id="element-3977">
                  <StatusBadge status={s.status} data-id="element-3978" />
                </td>
                <td className="px-5 py-3.5" data-id="element-3979">
                  <div className="flex justify-center" data-id="element-3980">
                    <SignedIcon s={s.signed} data-id="element-3981" />
                  </div>
                </td>
                <td className="px-5 py-3.5 text-right font-mono text-[#FAFAFA]" data-id="element-3982">
                  {s.cost}
                </td>
                <td className="px-5 py-3.5 text-right text-[#6B6B6B] text-xs" data-id="element-3983">
                  {s.updated}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </Widget>;
}